export const categories = [
  {
    id: 'oumei-movies',
    name: '欧美电影',
    slug: 'oumei-movies',
    icon: 'ri-film-line',
    description: '精选欧美最新大片与经典佳作，涵盖动作、科幻、剧情等多种类型',
    region: '欧美',
    type: '电影',
  },
  {
    id: 'oumei-tv',
    name: '欧美剧集',
    slug: 'oumei-tv',
    icon: 'ri-tv-line',
    description: '热门欧美电视剧、网剧、迷你剧，持续追踪最新季更新',
    region: '欧美',
    type: '剧集',
  },
  {
    id: 'oumei-music',
    name: '欧美音乐',
    slug: 'oumei-music',
    icon: 'ri-music-line',
    description: '欧美流行、摇滚、电子、古典音乐专辑与单曲精选推荐',
    region: '欧美',
    type: '音乐',
  },
  {
    id: 'japan-movies',
    name: '日本电影',
    slug: 'japan-movies',
    icon: 'ri-film-line',
    description: '日本动画电影、真人电影、文艺片精选，感受和风影像之美',
    region: '日本',
    type: '电影',
  },
  {
    id: 'japan-tv',
    name: '日本剧集',
    slug: 'japan-tv',
    icon: 'ri-tv-line',
    description: '最新日剧、经典日剧、动漫番剧推荐，追踪每季热门作品',
    region: '日本',
    type: '剧集',
  },
  {
    id: 'japan-music',
    name: '日本音乐',
    slug: 'japan-music',
    icon: 'ri-music-line',
    description: 'J-POP、动画歌曲、独立音乐，日本音乐文化精选导航',
    region: '日本',
    type: '音乐',
  },
  {
    id: 'korea-movies',
    name: '韩国电影',
    slug: 'korea-movies',
    icon: 'ri-film-line',
    description: '韩国犯罪、悬疑、爱情、文艺电影精选，韩影魅力无限',
    region: '韩国',
    type: '电影',
  },
  {
    id: 'korea-tv',
    name: '韩国剧集',
    slug: 'korea-tv',
    icon: 'ri-tv-line',
    description: '韩剧热门推荐，从浪漫爱情到悬疑惊悚，追剧指南一网打尽',
    region: '韩国',
    type: '剧集',
  },
  {
    id: 'korea-music',
    name: '韩国音乐',
    slug: 'korea-music',
    icon: 'ri-music-line',
    description: 'K-POP、韩国独立音乐、OST精选，韩流音乐文化前沿资讯',
    region: '韩国',
    type: '音乐',
  },
];

export const regionTabs = [
  { id: 'all', name: '全部' },
  { id: 'oumei', name: '欧美' },
  { id: 'japan', name: '日本' },
  { id: 'korea', name: '韩国' },
];

export const typeTabs = [
  { id: 'all', name: '全部' },
  { id: 'movies', name: '电影' },
  { id: 'tv', name: '剧集' },
  { id: 'music', name: '音乐' },
];